export default __webpack_public_path__ + "static/media/printer.dfffb787.png";